import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import MidInsStatus from './MidInsStatus.mjs'
import Model from './ModelMidins.mjs'

const PropertiesPaneMidins = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <Text prop="middlewareInsName" />
                <LongText prop="middlewareInsDesc" />
                <LongText prop="middlewareInsMemo" />
                <Text prop="middlewareInsVersion" />
                <Text prop="middlewareInsSchema" />
                <Text prop="middlewareInsIntranetIp" />
                <Text prop="middlewareInsInternetIp" />
                <Text prop="middlewareInsPort" />

                <Select
                    options={MidInsStatus}
                    prop="middlewareInsStatus"
                />

                <Text prop="middlewareInsBu" />
                <Text prop="middlewareInsDm" />
                <Text prop="middlewareInsOm" />
                <Text prop="middlewareInsEnv" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneMidins
